// extracted by mini-css-extract-plugin
module.exports = {"root":"ProjectIndex_root__36jCz","filter":"ProjectIndex_filter__1mQl8","projectArea":"ProjectIndex_projectArea__15d0-","noContent":"ProjectIndex_noContent__3ja0A"};